import { Injectable } from '@angular/core';

import { KeyValuePair } from '@reg/shared/model';

/**
 * Service to get measurement units
 */
@Injectable()
export class MeasurementUnitService {
    // Consts are a copy of the MeasurementUnit enum defined in the floarena-api
    public static get NA(): string {
        return '';
    }

    public static get LBS(): string {
        return 'lbs';
    }

    public static get KG(): string {
        return 'kg';
    }

    private types: KeyValuePair[] = [];

    /**
     * Constructor. Build the enum list
     */
    constructor() {
        this.types.push(new KeyValuePair(MeasurementUnitService.NA, 'NA'));
        this.types.push(new KeyValuePair(MeasurementUnitService.LBS, 'lbs'));
        this.types.push(new KeyValuePair(MeasurementUnitService.KG, 'kg'));
    }

    /**
     * Get all measurement units
     */
    public getIndex(excludeNA: boolean = true): KeyValuePair[] {
        if (excludeNA) {
            return this.types.filter((x: KeyValuePair) => x.key !== MeasurementUnitService.NA);
        }

        return this.types;
    }

    /**
     * Get a specific measurement unit
     */
    public get(measurementUnit: string): KeyValuePair {
        const unit: KeyValuePair = this.types.filter((x: KeyValuePair) => x.key === measurementUnit)[0];

        if (unit) {
            return unit.clone();
        }

        return null;
    }
}
